import styled from "styled-components";
import { useState } from "react";
import { Radio } from "antd";
import { Form, Button, Input, Row, Col, Select, Checkbox } from "library";
import { Body3, Body4 } from "components/Typography";

const Instituciones = [
  { label: "Universidad del Rosario", value: "Universidad del Rosario" },
  { label: "Universidad de Ibagué", value: "Universidad de Ibagué" },
  { label: "Uniminuto", value: "Uniminuto" },
  { label: "Universidad de Costa Rica", value: "Universidad de Costa Rica" },
  {
    label: "Universidad Estatal a Distancia",
    value: "Universidad Estatal a Distancia",
  },
  { label: "Tecnológico de Costa Rica", value: "Tecnológico de Costa Rica" },
  {
    label: "Universidad Técnica Nacional",
    value: "Universidad Técnica Nacional",
  },
  { label: "Tecnológico de Monterrey", value: "Tecnológico de Monterrey" },
  {
    label: "Universidad Tecnológica Centroamericana",
    value: "Universidad Tecnológica Centroamericana",
  },
  { label: "Universidad de Cuenca", value: "Universidad de Cuenca" },
  { label: "Otro", value: "Otro" },
];

const TiposDiscapacidad = [
  { label: "Visual", value: "Visual" },
  { label: "Auditiva", value: "Auditiva" },
  { label: "Motora", value: "Motora" },
  { label: "Psicosocial", value: "Psicosocial" },
  { label: "Sistémica", value: "Sistémica" },
  { label: "Cognitiva-Intelectual", value: "Cognitiva-Intelectual" },
];

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

interface Paso2NuevoProps {
  step1: { nombre: string; pais: string; identificacion: string };
  talleres: { label: string; value: number; disabled?: boolean }[];
  onFinish: (values: any) => void;
  onBack: () => void;
  onRefreshTalleres?: () => void;
  isSubmitting?: boolean;
}

/** Resto de campos para persona nueva en el periodo EIDU. */
export function Paso2Nuevo({
  step1,
  talleres,
  onFinish,
  onBack,
  onRefreshTalleres,
  isSubmitting = false,
}: Paso2NuevoProps) {
  const [pertenecienteA, setPertenecienteA] = useState<string>();
  const [tieneDiscapacidad, setTieneDiscapacidad] = useState("no");
  const [requiereApoyo, setRequiereApoyo] = useState("no");

  return (
    <FormContainer>
      <Body3 style={{ marginBottom: 24, fontSize: 20, lineHeight: "28px", fontWeight: 300, color: "#65696A" }}>
        Paso 2 de 2 — Complete su inscripción
      </Body3>
      <Form
        {...formItemLayout}
        onFinish={onFinish}
        name="eidu-prueba-paso2-nuevo"
        initialValues={{
          nombre: step1.nombre,
          pais: step1.pais,
          identificacion: step1.identificacion,
          tieneDiscapacidad: "no",
          requiereApoyo: "no",
        }}
        onValuesChange={(changed) => {
          if ("pertenecienteA" in changed) {
            setPertenecienteA(changed.pertenecienteA);
          }
          if ("tieneDiscapacidad" in changed) {
            setTieneDiscapacidad(changed.tieneDiscapacidad);
          }
          if ("requiereApoyo" in changed) {
            setRequiereApoyo(changed.requiereApoyo);
          }
        }}
      >
        <Row gutter={32}>
          <Col xs={24} lg={12}>
            <Form.Item label="Nombre completo" name="nombre">
              <Input disabled />
            </Form.Item>
            <Form.Item label="País" name="pais">
              <Input disabled />
            </Form.Item>
            <Form.Item label="Identificación" name="identificacion">
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="Correo de contacto"
              name="correoContacto"
              rules={[
                { required: true, message: "Campo requerido" },
                { type: "email", message: "Correo inválido" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Confirmación de correo de contacto"
              name="confirmacionCorreo"
              dependencies={["correoContacto"]}
              rules={[
                { required: true, message: "Campo requerido" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("correoContacto") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Los correos no coinciden")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Teléfono de contacto (incluir código de país)"
              name="telefono"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Input placeholder="Ej: +506 8888-8888" />
            </Form.Item>
            <Form.Item
              label="Perteneciente a"
              name="pertenecienteA"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Select
                options={Instituciones}
                placeholder="Seleccionar institución"
              />
            </Form.Item>
            {pertenecienteA === "Otro" && (
              <Form.Item
                label="Indique la institución"
                name="pertenecienteAOtro"
                rules={[{ required: true, message: "Campo requerido" }]}
              >
                <Input />
              </Form.Item>
            )}
          </Col>
          <Col xs={24} lg={12}>
            <Form.Item
              label="Unidad Académica (Facultad o Escuela)"
              name="unidad"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Programa Académico o Carrera"
              name="carrera"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Talleres de formación" name="taller">
              <Select
                allowClear
                options={talleres}
                placeholder="Sin taller / seleccionar uno"
                onDropdownVisibleChange={(open: boolean) => {
                  if (open) onRefreshTalleres?.();
                }}
              />
            </Form.Item>
            <Body4 style={{ color: "#65696A", marginBottom: 24 }}>
              Si desea participar en alguno de los talleres, puede solicitar un
              cupo en esta sección. Todos los talleres serán a las 8:30 a.m.
              Costa Rica | 9:30 a.m. Colombia. Los talleres tienen un cupo
              limitado y se asignan por orden de solicitud. Las personas
              seleccionadas recibirán un correo de confirmación. Las personas
              que no asistan a los talleres, tendrán la oportunidad de
              participar en las Salas de demostraciones (demos) de acuerdo a su
              interés.
            </Body4>
            <Form.Item
              label="¿Tiene alguna discapacidad?"
              name="tieneDiscapacidad"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Radio.Group>
                <Radio value="si">Sí</Radio>
                <Radio value="no">No</Radio>
              </Radio.Group>
            </Form.Item>
            {tieneDiscapacidad === "si" && (
              <Form.Item
                label='De haber respondido "Sí", indique el tipo'
                name="tipoDiscapacidad"
                rules={[
                  { required: true, message: "Seleccione al menos un tipo" },
                ]}
              >
                <Checkbox.Group options={TiposDiscapacidad} />
              </Form.Item>
            )}
            <Form.Item
              label="¿Requiere algún tipo de apoyo para su participación?"
              name="requiereApoyo"
              rules={[{ required: true, message: "Campo requerido" }]}
            >
              <Radio.Group>
                <Radio value="si">Sí</Radio>
                <Radio value="no">No</Radio>
              </Radio.Group>
            </Form.Item>
            {requiereApoyo === "si" && (
              <Form.Item
                label="Indique cuál"
                name="detalleApoyo"
                rules={[{ required: true, message: "Campo requerido" }]}
              >
                <Input />
              </Form.Item>
            )}
            <ButtonContainer>
              <Button onClick={onBack} variant="secondary">
                Volver
              </Button>
              <Button htmlType="submit" disabled={isSubmitting}>
                {isSubmitting ? "Enviando..." : "Completar inscripción"}
              </Button>
            </ButtonContainer>
          </Col>
        </Row>
      </Form>
    </FormContainer>
  );
}

const FormContainer = styled.div`
  .ant-form-item {
    margin-bottom: 24px;
  }
  .ant-form-item-label {
    padding-bottom: 0;
  }
  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  label {
    font-size: 12px;
    line-height: 19px;
    font-weight: bold;
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  button {
    flex: 1;
  }
`;
